import Vue from "vue";

export async function showCategory(category_id) {
  return Vue.prototype.$http.get(
    `/form_options/form_options_category/${category_id}`
  );
}
